module.exports = __webpack_public_path__ + "img/concrete-o.575d0ed9.png";